import React from 'react';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import SplitContainer from '@zippytech/react-toolkit/SplitContainer'
import SettingTree from './BrowserPane/SettingTree';
import BaseCategory from './Drive/KnowledgeBank/BaseCategory';
import Category from './Drive/KnowledgeBank/Category'
import SubCategory from './Drive/KnowledgeBank/SubCategory';
import SettingList from './DesignerPane/SettingList'
import CategoryListingCard from '../../drive/Categories/CategoryListingCard';
import IntegrationList from './Drive/Integration/IntegrationList'
import ConsumptionDashboard from './Drive/Consumption/ConsumptionDashboard';
import ConsumptionBilling from './Drive/Consumption/ConsumptionBilling';
import SystemNotification from './DesignerPane/SystemNotification'
import AddSystemNotificationModal from './Drive/SystemNotification/AddSystemNotificationModal'
import EditSystemNotificationModal from './Drive/SystemNotification/EditSystemNotificationModal'
import DeleteSystemNotificationModal from './Drive/SystemNotification/DeleteSystemNotificationModal'
import { PricingPage } from '../../staticweb/PricingPage';
class Settings extends React.Component {


  async componentDidMount() {

    await dispatch.integrations.getIntegrations()

    


    let isDisabled = false;
    let account = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0];
    if (account.role === "user") {
      isDisabled = true;
    } else if (account.role === "customerAdmin" && !account.isActive) {
      isDisabled = true;
    }

    if (isDisabled) {
      this.props.history.push({
        pathname: `/app/${this.props.selectedAccount._id}/dashboard`
      });
    }
  }

  render() {
    return (
      <SplitContainer bordered
        orientation="vertical"
        minSize="10%"
        maxSize={['50%', null]}
        fillSides={[true, true]}
        collapsible={[true, false]}
        defaultSplitAt="15%"
        resizeProxy={true}
      >
        <SplitContainer.Side className="setOverflow " >
          <SettingTree {...this.props} />
        </SplitContainer.Side>

        <SplitContainer.Side className="pad_20" style={{ height: "100%", overflow: 'auto' }} >
          <Route exact path="/app/platform/settings" render={() => (<SettingList  {...this.props} />)} />
          <Route exact path="/app/platform/settings/public" render={() => (<CategoryListingCard  {...this.props} level="platform" levelDepth="baseCategory" />)} />
          <Route exact path="/app/platform/settings/public/:baseCategoryId" render={() => (<CategoryListingCard  {...this.props} level="platform" levelDepth="category" />)} />
          <Route exact path="/app/platform/settings/public/:baseCategoryId/:categoryId" render={() => (<CategoryListingCard  {...this.props} level="platform" levelDepth="subCategory" />)} />
          <Route exact path="/app/platform/settings/integration" render={() => (<IntegrationList  {...this.props} />)} />
          <Route exact path="/app/platform/settings/consumption-dashboard" render={() => (<ConsumptionDashboard  {...this.props} />)} />
          <Route exact path="/app/platform/settings/consumption-billing" render={() => (<ConsumptionBilling  {...this.props} />)} />
          <Route exact path="/app/platform/settings/integration/:integrationName" render={() => (<IntegrationList  {...this.props} />)} />
          <Route exact path="/app/platform/settings/systemNotification" render={() => (<SystemNotification  {...this.props} level="workspace" />)} />
          <Route exact path="/app/platform/settings/systemNotification/:notificationId" render={() => (<AddSystemNotificationModal  {...this.props} level="workspace" />)} />
          <Route exact path="/app/platform/settings/systemNotification/:notificationId" render={() => (<EditSystemNotificationModal  {...this.props} level="workspace" />)} />
          <Route exact path="/app/platform/settings/systemNotification/:notificationId" render={() => (<DeleteSystemNotificationModal  {...this.props} level="workspace" />)} />
          <Route exact path="/app/platform/settings/pricing-page" render={() => (<PricingPage  {...this.props} level="workspace" />)} /> 
          {/*<Route exact path="/app/platform/settings/public" render={() => (<BaseCategory  {...this.props} />)} />
          <Route exact path="/app/platform/settings/public/:baseCategory" render={() => (<Category  {...this.props} />)} />
          <Route exact path="/app/platform/settings/public/:baseCategory/:category" render={() => (<SubCategory  {...this.props} />)} />
          <Route exact path="/app/platform/settings/public/:baseCategory/:category/:subCategory" render={() => (<SubCategory  {...this.props} />)} /> */}
        </SplitContainer.Side>
      </SplitContainer>
    )
  }
}

function mapStateToProps(state) {
  return {
    selectedAccount: state.app.selectedAccount,
    categoryTree: state.lifeCycle.categoryTree,
    categoryPublicTree: state.lifeCycle.categoryPublicTree,
    baseCategoriesArr: state.lifeCycle.baseCategoriesArr,
    categoriesArr: state.lifeCycle.categoriesArr,
    subCategoriesArr: state.lifeCycle.subCategoriesArr,
    isCategoryChange: state.account.isCategoryChange,
    isAddCategoryModalOpen: state.account.isAddCategoryModalOpen,
    user: state.app.user,
    isDeleteCategoryModalOpen: state.account.isDeleteCategoryModalOpen,
    deleteLoader: state.loading.effects.account.deleteCategoryAsync,
    addCategoryLoader: state.loading.effects.account.createCategory,
    selectedCategory: state.account.selectedCategory,
    categoryTreeId: state.account.categoryTreeId,
    mainAreaContext: state.community.mainAreaContext,
    allCategoryList: state.categories.allCategoryList,
    categoryTreeById: state.categories.categoryTreeById,
    newIntegrationFlag: state.platform.newIntegrationFlag,
    envData: state.app.envData,
    integrationsList:state.integrations.integrationsList,
    integrationModalType:state.platform.integrationModalType,
    systemNotificationById: state.systemNotification.systemNotificationById,
    allSystemNotificationList: state.systemNotification.allSystemNotificationList,
    categoryListLoader: state.categories.categoryListLoader,
    consumptionDetails: state.account.consumptionDetails,
    loadingConsumptions: state.loading.effects.account.getConsumptionDetails,
    activitiesGenerated: state.account.activitiesGenerated,
    playbooksCreated: state.account.playbooksCreated,
    linksGenerated: state.account.linksGenerated,
    billingDefaults: state.account.billingDefaults,
  };
}

const connectedSettings = connect(mapStateToProps)(Settings);
export { connectedSettings as Settings }; 